export default __webpack_public_path__ + "static/media/japantrad8.5610ff31.png";